import React, { useEffect, useState } from "react";
import { ScrollPanel } from "primereact/scrollpanel";
import axios from "axios";
import formatDateTimeMadagascar from "../convertTime";


const apiUrl = process.env.REACT_APP_API_URL;

export default function FicheLogTerminal({ idFicheLeads }) {
  const [logData, setLogData] = useState([]);

  // Mapping des états
  const etatLabels = {
    "0": "Nouvelle",
    "1": "En cours",
    "2": "Suivis",
    "3": "Validés",
    "4": "Réalisés",
    "5": "Abandons"
  };

  // Mapping des champs pour l'affichage
  const champLabels = {
    etat: "État",
    vous_etes: "Type client",
    nomPrenom: "Nom / Prenom",
    email: "Email",
    tel: "Téléphone",
    lieu: "Lieu",
    nbpers: "Nombre personnes",
    type_bar: "Type bar",
    barman: "Barman",
    more: "Détails",
    dateValidation: "Validation",
    dernierAppel: "Dernier appel",
    nbappels: "Nb appels",
    is_completed: "Formulaire complet",
    dateFicheLead: "Date création",
    note: "Note"
  };

  function isValidDate(value) {
    const date = new Date(value);
    return !isNaN(date.getTime()) && /^\d{4}-\d{2}-\d{2}/.test(value);
  }

  // Formater la valeur selon le champ
  function formatValeur(champ, valeur) {
    if (valeur === null || valeur === undefined || valeur === "" || valeur === "0000-00-00") {
      return null;
    }

    // Pour l'état, mapper le chiffre vers le libellé
    if (champ === "etat") {
      return etatLabels[valeur] || valeur;
    }

    // Pour les dates
    if (champ === "dateValidation" || champ === "dernierAppel" || champ === "dateFicheLead") {
      const date = new Date(valeur);
      if (!isNaN(date.getTime())) {
        return date.toLocaleDateString();
      }
    }

    return valeur;
  }

  useEffect(() => {
    if (!idFicheLeads) return;

    axios
      .get(`${apiUrl}/IHM/api/lead.php?journalFiche=${idFicheLeads}`)
      .then((res) => {
        setLogData(res.data);
      })
      .catch((err) => {
        console.error("Erreur lors de la récupération du log :", err);
      });
  }, [idFicheLeads]);

  const allLogs = [...logData]
    .filter((entry) => entry.date_action)
    .sort((a, b) => new Date(b.date_action) - new Date(a.date_action));

  const formatDateLocal = (datetimeStr) => {
    const d = new Date(datetimeStr);
    return `${d.toLocaleDateString()} ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
  };

  return (
    <>
      <div className="grid">
        <div className="col-12 md:col-12 font-bold">
          <div className="py-0 border-round-sm surface-100 flex flex-column">
            Historique des actions :
          </div>
        </div>
      </div>

      <div className="grid">
        <div className="col-12 md:col-12">
          {allLogs.map((entry, index) => {
            const formattedOldValue = formatValeur(entry.champ_modifie, entry.ancienne_valeur);
            const formattedNewValue = formatValeur(entry.champ_modifie, entry.nouvelle_valeur);
            const champName = champLabels[entry.champ_modifie] || entry.champ_modifie;
            
            return (
              <div
                key={index}
                style={{
                  padding: "10px",
                  fontSize: "0.75rem",
                  border: "1px solid #f3f4f6",
                  background: "#f3f4f6",
                  borderRadius: "5px",
                  marginBottom: "2px",
                }}
              >
                {/* Date et type d'action */}
                <span>
                  [{formatDateTimeMadagascar(entry.date_action)}]
                </span>{" "}
                
                {/* Action INSERT */}
                {entry.action_type?.toUpperCase() === "INSERT" && (
                  <span>Création du lead</span>
                )}
                
                {/* Action UPDATE */}
                {entry.action_type?.toUpperCase() === "UPDATE" && (
                  <>
                    <span>
                      {champName}
                    </span>
                    {/* Affichage du changement */}
                    {formattedOldValue && formattedNewValue && (
                      <span>
                        {" "}: {formattedNewValue}
                      </span>
                    )}
                    
                    {!formattedOldValue && formattedNewValue && (
                      <span>: {formattedNewValue}</span>
                    )}
                    
                    {entry.utilisateur && (
                      <span> [{entry.utilisateur}]</span>
                    )}

                    {entry.message && (
                      <span>
                        {" "}Note : {entry.note}
                      </span>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}